// import moment from 'moment'
// import React from 'react'
//
// const now = new Date ()

export default [
  {
    id: 0,
    'title': 'RACE DAY!',
    'start': new Date(2019, 7, 18),
    'end': new Date(2019, 7, 18),
    'distance': 'Full Ironman',
    'time': 'As fast as you can!'
  },
  {
    id: 1,
    'title': 'Run',
    'start': new Date(2019, 7, 17),
    'end': new Date(2019, 7, 17),
    'distance': '-',
    'time': ':20'
  },
  {
    id: 2,
    'title': 'Swim',
    'start': new Date(2019, 7, 16),
    'end': new Date(2019, 7, 16),
    'distance': '-',
    'time': ':20'
  },
  {
    id: 3,
    'title': 'Bike',
    'start': new Date(2019, 7, 16),
    'end': new Date(2019, 7, 16),
    'distance': '-',
    'time': ':40'
  },
  {
    id: 4,
    'title': 'Run',
    'start': new Date(2019, 7, 15),
    'end': new Date(2019, 7, 15),
    'distance': '-',
    'time': ':40'
  },
  {
    id: 5,
    'title': 'Swim',
    'start': new Date(2019, 7, 14),
    'end': new Date(2019, 7, 14),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 6,
    'title': 'Bike',
    'start': new Date(2019, 7, 14),
    'end': new Date(2019, 7, 14),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 7,
    'title': 'Bike',
    'start': new Date(2019, 7, 13),
    'end': new Date(2019, 7, 13),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 8,
    'title': 'Run',
    'start': new Date(2019, 7, 13),
    'end': new Date(2019, 7, 13),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 9,
    'title': 'Swim',
    'start': new Date(2019, 7, 12),
    'end': new Date(2019, 7, 12),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 10,
    'title': 'Run',
    'start': new Date(2019, 7, 11),
    'end': new Date(2019, 7, 11),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 11,
    'title': 'Bike',
    'start': new Date(2019, 7, 10),
    'end': new Date(2019, 7, 10),
    'distance': '-',
    'time': '2:30'
  },
  {
    id: 12,
    'title': 'Run',
    'start': new Date(2019, 7, 10),
    'end': new Date(2019, 7, 10),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 13,
    'title': 'Swim',
    'start': new Date(2019, 7, 9),
    'end': new Date(2019, 7, 9),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 14,
    'title': 'Run',
    'start': new Date(2019, 7, 8),
    'end': new Date(2019, 7, 8),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 15,
    'title': 'Swim',
    'start': new Date(2019, 7, 7),
    'end': new Date(2019, 7, 7),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 16,
    'title': 'Bike',
    'start': new Date(2019, 7, 7),
    'end': new Date(2019, 7, 7),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 17,
    'title': 'Bike',
    'start': new Date(2019, 7, 6),
    'end': new Date(2019, 7, 6),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 18,
    'title': 'Run',
    'start': new Date(2019, 7, 6),
    'end': new Date(2019, 7, 6),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 19,
    'title': 'Swim',
    'start': new Date(2019, 7, 5),
    'end': new Date(2019, 7, 5),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 20,
    'title': 'Run',
    'start': new Date(2019, 7, 4),
    'end': new Date(2019, 7, 4),
    'distance': '-',
    'time': '2:00'
  },
  {
    id: 21,
    'title': 'Swim',
    'start': new Date(2019, 7, 3),
    'end': new Date(2019, 7, 3),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 22,
    'title': 'Bike',
    'start': new Date(2019, 7, 3),
    'end': new Date(2019, 7, 3),
    'distance': '-',
    'time': '4:00'
  },
  {
    id: 23,
    'title': 'Run',
    'start': new Date(2019, 7, 3),
    'end': new Date(2019, 7, 3),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 24,
    'title': 'OFF',
    'start': new Date(2019, 7, 2),
    'end': new Date(2019, 7, 2),
    'distance': '-',
    'time': '-'
  },
  {
    id: 25,
    'title': 'Run',
    'start': new Date(2019, 7, 1),
    'end': new Date(2019, 7, 1),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 26,
    'title': 'Swim',
    'start': new Date(2019, 6, 31),
    'end': new Date(2019, 6, 31),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 27,
    'title': 'Bike',
    'start': new Date(2019, 6, 31),
    'end': new Date(2019, 6, 31),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 28,
    'title': 'Bike',
    'start': new Date(2019, 6, 30),
    'end': new Date(2019, 6, 30),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 29,
    'title': 'Run',
    'start': new Date(2019, 6, 30),
    'end': new Date(2019, 6, 30),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 30,
    'title': 'Swim',
    'start': new Date(2019, 6, 29),
    'end': new Date(2019, 6, 29),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 31,
    'title': 'Run',
    'start': new Date(2019, 6, 28),
    'end': new Date(2019, 6, 28),
    'distance': '-',
    'time': '1:45'
  },
  {
    id: 32,
    'title': 'Swim',
    'start': new Date(2019, 6, 27),
    'end': new Date(2019, 6, 27),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 33,
    'title': 'Bike',
    'start': new Date(2019, 6, 27),
    'end': new Date(2019, 6, 27),
    'distance': '-',
    'time': '4:00'
  },
  {
    id: 34,
    'title': 'Swim',
    'start': new Date(2019, 6, 26),
    'end': new Date(2019, 6, 26),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 35,
    'title': 'SC',
    'start': new Date(2019, 6, 26),
    'end': new Date(2019, 6, 26),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 36,
    'title': 'Bike',
    'start': new Date(2019, 6, 25),
    'end': new Date(2019, 6, 25),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 37,
    'title': 'Run',
    'start': new Date(2019, 6, 25),
    'end': new Date(2019, 6, 25),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 38,
    'title': 'Bike',
    'start': new Date(2019, 6, 24),
    'end': new Date(2019, 6, 24),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 39,
    'title': 'Run',
    'start': new Date(2019, 6, 23),
    'end': new Date(2019, 6, 23),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 40,
    'title': 'Swim',
    'start': new Date(2019, 6, 22),
    'end': new Date(2019, 6, 22),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 41,
    'title': 'Run',
    'start': new Date(2019, 6, 21),
    'end': new Date(2019, 6, 21),
    'distance': '-',
    'time': '2:00'
  },
  {
    id: 42,
    'title': 'Bike',
    'start': new Date(2019, 6, 20),
    'end': new Date(2019, 6, 20),
    'distance': '-',
    'time': '5:30'
  },
  {
    id: 43,
    'title': 'Swim',
    'start': new Date(2019, 6, 19),
    'end': new Date(2019, 6, 19),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 44,
    'title': 'SC',
    'start': new Date(2019, 6, 19),
    'end': new Date(2019, 6, 19),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 45,
    'title': 'Bike',
    'start': new Date(2019, 6, 18),
    'end': new Date(2019, 6, 18),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 46,
    'title': 'Run',
    'start': new Date(2019, 6, 18),
    'end': new Date(2019, 6, 18),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 47,
    'title': 'Swim',
    'start': new Date(2019, 6, 17),
    'end': new Date(2019, 6, 17),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 48,
    'title': 'Run',
    'start': new Date(2019, 6, 17),
    'end': new Date(2019, 6, 17),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 49,
    'title': 'Bike',
    'start': new Date(2019, 6, 16),
    'end': new Date(2019, 6, 16),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 50,
    'title': 'Swim',
    'start': new Date(2019, 6, 15),
    'end': new Date(2019, 6, 15),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 51,
    'title': 'Run',
    'start': new Date(2019, 6, 14),
    'end': new Date(2019, 6, 14),
    'distance': '-',
    'time': '2:30'
  },
  {
    id: 52,
    'title': 'Bike',
    'start': new Date(2019, 6, 13),
    'end': new Date(2019, 6, 13),
    'distance': '-',
    'time': '4:20'
  },
  {
    id: 53,
    'title': 'Run',
    'start': new Date(2019, 6, 13),
    'end': new Date(2019, 6, 13),
    'distance': '-',
    'time': ':15'
  },
  {
    id: 54,
    'title': 'Swim',
    'start': new Date(2019, 6, 12),
    'end': new Date(2019, 6, 12),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 55,
    'title': 'Bike',
    'start': new Date(2019, 6, 11),
    'end': new Date(2019, 6, 11),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 56,
    'title': 'Run',
    'start': new Date(2019, 6, 11),
    'end': new Date(2019, 6, 11),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 57,
    'title': 'Swim',
    'start': new Date(2019, 6, 10),
    'end': new Date(2019, 6, 10),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 58,
    'title': 'Run',
    'start': new Date(2019, 6, 9),
    'end': new Date(2019, 6, 9),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 59,
    'title': 'Bike',
    'start': new Date(2019, 6, 9),
    'end': new Date(2019, 6, 9),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 60,
    'title': 'Swim',
    'start': new Date(2019, 6, 8),
    'end': new Date(2019, 6, 8),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 61,
    'title': 'SC',
    'start': new Date(2019, 6, 8),
    'end': new Date(2019, 6, 8),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 62,
    'title': 'Run',
    'start': new Date(2019, 6, 7),
    'end': new Date(2019, 6, 7),
    'distance': '-',
    'time': '1:45'
  },
  {
    id: 63,
    'title': 'Bike',
    'start': new Date(2019, 6, 6),
    'end': new Date(2019, 6, 6),
    'distance': '-',
    'time': '4:20'
  },
  {
    id: 64,
    'title': 'Run',
    'start': new Date(2019, 6, 6),
    'end': new Date(2019, 6, 6),
    'distance': '-',
    'time': ':15'
  },
  {
    id: 65,
    'title': 'Swim',
    'start': new Date(2019, 6, 5),
    'end': new Date(2019, 6, 5),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 66,
    'title': 'Bike',
    'start': new Date(2019, 6, 4),
    'end': new Date(2019, 6, 4),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 67,
    'title': 'Run',
    'start': new Date(2019, 6, 4),
    'end': new Date(2019, 6, 4),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 68,
    'title': 'Swim',
    'start': new Date(2019, 6, 3),
    'end': new Date(2019, 6, 3),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 69,
    'title': 'Run',
    'start': new Date(2019, 6, 2),
    'end': new Date(2019, 6, 2),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 70,
    'title': 'SC',
    'start': new Date(2019, 6, 2),
    'end': new Date(2019, 6, 2),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 71,
    'title': 'OFF',
    'start': new Date(2019, 6, 1),
    'end': new Date(2019, 6, 1),
    'distance': '-',
    'time': '-'
  },
  {
    id: 72,
    'title': 'Run',
    'start': new Date(2019, 5, 30),
    'end': new Date(2019, 5, 30),
    'distance': '-',
    'time': '2:30'
  },
  {
    id: 73,
    'title': 'Swim',
    'start': new Date(2019, 5, 30),
    'end': new Date(2019, 5, 30),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 74,
    'title': 'Bike',
    'start': new Date(2019, 5, 29),
    'end': new Date(2019, 5, 29),
    'distance': '-',
    'time': '5:00'
  },
  {
    id: 75,
    'title': 'Run',
    'start': new Date(2019, 5, 29),
    'end': new Date(2019, 5, 29),
    'distance': '-',
    'time': ':15'
  },
  {
    id: 76,
    'title': 'Swim',
    'start': new Date(2019, 5, 28),
    'end': new Date(2019, 5, 28),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 77,
    'title': 'Bike',
    'start': new Date(2019, 5, 27),
    'end': new Date(2019, 5, 27),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 78,
    'title': 'Run',
    'start': new Date(2019, 5, 27),
    'end': new Date(2019, 5, 27),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 79,
    'title': 'Swim',
    'start': new Date(2019, 5, 26),
    'end': new Date(2019, 5, 26),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 80,
    'title': 'Bike',
    'start': new Date(2019, 5, 26),
    'end': new Date(2019, 5, 26),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 81,
    'title': 'Run',
    'start': new Date(2019, 5, 25),
    'end': new Date(2019, 5, 25),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 82,
    'title': 'SC',
    'start': new Date(2019, 5, 24),
    'end': new Date(2019, 5, 24),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 83,
    'title': 'Run',
    'start': new Date(2019, 5, 23),
    'end': new Date(2019, 5, 23),
    'distance': '-',
    'time': '2:30'
  },
  {
    id: 84,
    'title': 'Swim',
    'start': new Date(2019, 5, 23),
    'end': new Date(2019, 5, 23),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 85,
    'title': 'Bike',
    'start': new Date(2019, 5, 22),
    'end': new Date(2019, 5, 22),
    'distance': '-',
    'time': '4:30'
  },
  {
    id: 86,
    'title': 'Run',
    'start': new Date(2019, 5, 22),
    'end': new Date(2019, 5, 22),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 87,
    'title': 'Swim',
    'start': new Date(2019, 5, 21),
    'end': new Date(2019, 5, 21),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 88,
    'title': 'Bike',
    'start': new Date(2019, 5, 20),
    'end': new Date(2019, 5, 20),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 89,
    'title': 'Run',
    'start': new Date(2019, 5, 20),
    'end': new Date(2019, 5, 20),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 90,
    'title': 'Swim',
    'start': new Date(2019, 5, 19),
    'end': new Date(2019, 5, 19),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 91,
    'title': 'SC',
    'start': new Date(2019, 5, 19),
    'end': new Date(2019, 5, 19),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 92,
    'title': 'Run',
    'start': new Date(2019, 5, 18),
    'end': new Date(2019, 5, 18),
    'distance': '-',
    'time': ':40'
  },
  {
    id: 93,
    'title': 'OFF',
    'start': new Date(2019, 5, 17),
    'end': new Date(2019, 5, 17),
    'distance': '-',
    'time': '-'
  },
  {
    id: 94,
    'title': 'Run',
    'start': new Date(2019, 5, 16),
    'end': new Date(2019, 5, 16),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 95,
    'title': 'Swim',
    'start': new Date(2019, 5, 15),
    'end': new Date(2019, 5, 15),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 96,
    'title': 'Bike',
    'start': new Date(2019, 5, 15),
    'end': new Date(2019, 5, 15),
    'distance': '-',
    'time': '4:00'
  },
  {
    id: 97,
    'title': 'Run',
    'start': new Date(2019, 5, 15),
    'end': new Date(2019, 5, 15),
    'distance': '-',
    'time': ':20'
  },
  {
    id: 98,
    'title': 'Swim',
    'start': new Date(2019, 5, 14),
    'end': new Date(2019, 5, 14),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 99,
    'title': 'Bike',
    'start': new Date(2019, 5, 13),
    'end': new Date(2019, 5, 13),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 100,
    'title': 'SC',
    'start': new Date(2019, 5, 13),
    'end': new Date(2019, 5, 13),
    'distance': '-',
    'time': ':45'
  },
  {
    id: 101,
    'title': 'Run',
    'start': new Date(2019, 5, 11),
    'end': new Date(2019, 5, 11),
    'distance': '-',
    'time': ':40'
  },
  {
    id: 102,
    'title': 'OFF',
    'start': new Date(2019, 5, 10),
    'end': new Date(2019, 5, 10),
    'distance': '-',
    'time': '-'
  },
  {
    id: 103,
    'title': 'Run',
    'start': new Date(2019, 5, 9),
    'end': new Date(2019, 5, 9),
    'distance': '-',
    'time': '2:15'
  },
  {
    id: 104,
    'title': 'Swim',
    'start': new Date(2019, 5, 9),
    'end': new Date(2019, 5, 9),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 105,
    'title': 'Bike',
    'start': new Date(2019, 5, 8),
    'end': new Date(2019, 5, 8),
    'distance': '-',
    'time': '3:30'
  },
  {
    id: 106,
    'title': 'Swim',
    'start': new Date(2019, 5, 7),
    'end': new Date(2019, 5, 7),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 107,
    'title': 'SC',
    'start': new Date(2019, 5, 7),
    'end': new Date(2019, 5, 7),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 108,
    'title': 'Bike',
    'start': new Date(2019, 5, 6),
    'end': new Date(2019, 5, 6),
    'distance': '-',
    'time': '1:15'
  },
  {
    id: 109,
    'title': 'Run',
    'start': new Date(2019, 5, 6),
    'end': new Date(2019, 5, 6),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 110,
    'title': 'Swim',
    'start': new Date(2019, 5, 5),
    'end': new Date(2019, 5, 5),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 111,
    'title': 'Run',
    'start': new Date(2019, 5, 4),
    'end': new Date(2019, 5, 4),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 112,
    'title': 'Bike',
    'start': new Date(2019, 5, 4),
    'end': new Date(2019, 5, 4),
    'distance': '-',
    'time': '1:00'
  },
  {
    id: 113,
    'title': 'SC',
    'start': new Date(2019, 5, 3),
    'end': new Date(2019, 5, 3),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 114,
    'title': 'Run',
    'start': new Date(2019, 5, 2),
    'end': new Date(2019, 5, 2),
    'distance': '-',
    'time': '1:30'
  },
  {
    id: 115,
    'title': 'Swim',
    'start': new Date(2019, 5, 2),
    'end': new Date(2019, 5, 2),
    'distance': '-',
    'time': ':30'
  },
  {
    id: 116,
    'title': 'Bike',
    'start': new Date(2019, 5, 1),
    'end': new Date(2019, 5, 1),
    'distance': '-',
    'time': '4:00'
  },
  {
    id: 117,
    'title': 'Run',
    'start': new Date(2019, 5, 1),
    'end': new Date(2019, 5, 1),
    'distance': '-',
    'time': ':30'
  }
]



// WEBPACK FOOTER //
// ./src/calendar/Events.js